export enum AclRoleState {
  Active = 'active',
  Deleted = 'deleted',
}
